import { parse, stringify } from 'qs';
import { useEffect, useState } from 'react';

export const generateLink = (
  link: string,
  params?: Record<string, string>
): string => {
  const [path, query] = link.split('?');
  const queryParams = parse(query);
  const newQueryParams = { ...queryParams, ...params };
  const hasQueryParams = Object.keys(newQueryParams).length > 0;

  return `${path}${hasQueryParams ? '?' : ''}${stringify(newQueryParams)}`;
};

// Use generated link only after initial render, for SEO reasons
export const useGeneratedLink = (
  link: string,
  params?: Record<string, string>
): string => {
  const [resultingLink, setResultingLink] = useState(link);

  const generatedLink = generateLink(link, params);

  useEffect(() => {
    setResultingLink(generatedLink);
  }, [generatedLink]);

  return resultingLink;
};
